/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { EchoResponseFromJSON, } from '../models';
/**
 *
 */
var EchoServiceApi = /** @class */ (function (_super) {
    __extends(EchoServiceApi, _super);
    function EchoServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This end point returns the same massage as specified in \'message\' parameter.<br> <br> This end point has no access restriction and publicly accessible.
     * This end point returns the same massage as specified in \'message\' parameter.
     */
    EchoServiceApi.prototype.getEchoRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.message !== undefined) {
                            queryParameters['message'] = requestParameters.message;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/echo",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return EchoResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This end point returns the same massage as specified in \'message\' parameter.<br> <br> This end point has no access restriction and publicly accessible.
     * This end point returns the same massage as specified in \'message\' parameter.
     */
    EchoServiceApi.prototype.getEcho = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEchoRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EchoServiceApi;
}(runtime.BaseAPI));
export { EchoServiceApi };
